import script from "./EditNoteForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditNoteForm.vue?vue&type=script&setup=true&lang=js"

import "./EditNoteForm.vue?vue&type=style&index=0&id=1527b886&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1527b886"]])

export default __exports__